<script>
    export default {
        name: 'ribbon controls',
        props: {
            pages: {
                type: Array,
                required: false,
                default: []
            },
            activePage: {
                type: String,
                default: 'orders'
            }
        },
        data: () => ({

        }),
        methods: {
            changeActivePage(newValue) {
                this.$emit('changeActivePage', newValue);
            }
        }
    }
</script>

<template>
    <div class="ribbon">
        <div v-for="page of pages" class="ribbon-elem-outer" @click="changeActivePage(page.name)">
            <router-link :to="{name: page.name}" :class="['ribbon-elem', page.name === activePage ? 'active' : '']">
                <span>{{ page.header }}</span>
            </router-link>
        </div>
    </div>
</template>

<style scoped lang="scss">
@use '~@/assets/styles/vars' as *;
    .ribbon {
        display: inline-flex !important;
        width: auto;
        flex-direction: row;
        align-items: center;
        background: $white;
        border-radius: 10px;
        padding: 3px;
        box-sizing: border-box;
        gap: 2px;
    }

    .ribbon-elem {
        background: transparent;
        color: $black;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        padding: 7px 10px;
        border-radius: 10px;
        cursor: pointer;
    }

    .ribbon-elem.active {
        background: $black;
        color: $white
    }

    span {
        font-size: 11.5px;
        text-transform: uppercase;
        font-weight: 500;
    }

    @media screen and (max-width: 750px) {
        .ribbon-elem {
            padding: 6px 8px;
        }

        span {
            font-size: 10px;
        }
    }
</style>